export default __webpack_public_path__ + "img/050decbf7c16abb95e7b1406b4968fd6.png";